import React, { useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import {  useNavigate, useParams } from 'react-router-dom';
import { resetPasswordCheckCode, resetPasswordCheckUUID } from "../../api/auth.ts";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import LogoComponent from "../../components/LogoComponent";

export default function ResetPasswordCodeVerificationPage() {
  const { t } = useContext(TranslatorContext);
  const navigate = useNavigate();

  const { uuid } = useParams()

  const [formData, setFormData] = useState({
    codigo: "",
  });
  const [displayPage, setDisplayPage] = useState(true);

  useEffect(() => {

    if(!uuid)
    setDisplayPage(false);
    else
    resetPasswordCheckUUID(uuid)
      .then((res) => {
        if (res.error === false) {
          setDisplayPage(true);
        } else {
          setDisplayPage(false);
        }
      })

  }, [uuid]);
 
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 

  const handleSubmit = (e) => {
    
    e.preventDefault();

    console.log(uuid);
    console.log(formData);

    resetPasswordCheckCode(uuid, formData.codigo).then((res) => {
      if (res.error === true) {
        Swal.fire({
          text: res.msg,
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      } else {
        
        Swal.fire({
          text: "Código verificado correctamente.",
          icon: "success",
          confirmButtonText: "Ok",
        });
        navigate('/recuperar-password/modificar/' +uuid);
       
      }
    });
  };

  

  return (
    <div>
     { displayPage ?
        <div className="mc-auth" translate="no">
          {/* Header con logo */}
          <div className="mc-auth-header">
            <img src="/images/logo.png" alt="CRISTOUR" className="mc-auth-logo-header" />
            <div className="mc-auth-help">
              <div className="mc-auth-feature-icon">
                <img src="/images/support.png" alt="Soporte" />
              </div>
              <span>¿Necesitas ayuda?</span>
              <a href="mailto:contacto@cristourviajes.cl">contacto@cristourviajes.cl</a>
            </div>
          </div>

          {/* Contenedor principal */}
          <div className="mc-auth-container">
            {/* Contenedor único - Bienvenida y Formulario */}
            <div className="mc-auth-welcome">
              <div className="mc-auth-welcome-content">
                <h1 className="mc-auth-welcome-title">Verifica tu<br />código</h1>
                <p className="mc-auth-welcome-subtitle">Ingresa el código de 4 dígitos que recibiste en tu email.</p>
              </div>

              {/* Formulario de verificación */}
              <div className="mc-auth-form-wrapper">
                <h2 className="mc-auth-form-title">Verificar Código</h2>
                <p className="mc-auth-form-subtitle">Ingresa el código enviado</p>

                <form className="mc-auth-form" onSubmit={handleSubmit} translate="no">
                  <div className="mc-auth-input-group">
                    <IconFieldComponent
                      icon="lock"
                      type="text"
                      name="codigo"
                      required
                      classes="w-100"
                      placeholder="0000"
                      onChange={handleInputChange}
                    />
                  </div>

                  <ButtonComponent className="mc-auth-btn-submit" type="submit">
                    VALIDAR CÓDIGO
                  </ButtonComponent>

                  <AnchorComponent className="mc-auth-forgot-link" to="/login">
                    Volver a login
                  </AnchorComponent>
                </form>
              </div>
            </div>
          </div>

          {/* Footer con características */}
          <footer className="mc-auth-footer">
            <div className="mc-auth-footer-content">
              <div className="mc-auth-feature-card">
                <div className="mc-auth-feature-icon">
                  <img src="/images/trips.png" alt="Mis Giras" onError={(e) => e.target.style.display = 'none'} />
                </div>
                <h3 className="mc-auth-feature-title">Mis Giras</h3>
                <p className="mc-auth-feature-desc">Revisa itinerarios, fechas, servicios y documentos de tus giras.</p>
              </div>

              <div className="mc-auth-feature-card">
                <div className="mc-auth-feature-icon">
                  <img src="/images/passengers.png" alt="Pasajeros" onError={(e) => e.target.style.display = 'none'} />
                </div>
                <h3 className="mc-auth-feature-title">Pasajeros</h3>
                <p className="mc-auth-feature-desc">Consulta la lista de pasajeros, datos y documentación.</p>
              </div>

              <div className="mc-auth-feature-card">
                <div className="mc-auth-feature-icon">
                  <img src="/images/payments.png" alt="Pagos" onError={(e) => e.target.style.display = 'none'} />
                </div>
                <h3 className="mc-auth-feature-title">Pagos</h3>
                <p className="mc-auth-feature-desc">Visualiza montos y fechas de pagos de tu gira.</p>
              </div>

              <div className="mc-auth-feature-card">
                <div className="mc-auth-feature-icon">
                  <img src="/images/documents.png" alt="Documentos" onError={(e) => e.target.style.display = 'none'} />
                </div>
                <h3 className="mc-auth-feature-title">Documentos</h3>
                <p className="mc-auth-feature-desc">Descarga contratos, coberturas y documentos importantes.</p>
              </div>
            </div>
          </footer>
        </div>
       :
       <div className="mc-auth" translate="no">
          {/* Header con logo */}
          <div className="mc-auth-header">
            <img src="images/logo.png" alt="CRISTOUR" className="mc-auth-logo-header" />
            <div className="mc-auth-help">
              <div className="mc-auth-feature-icon">
                <img src="images/support.png" alt="Soporte" />
              </div>
              <span>¿Necesitas ayuda?</span>
              <a href="mailto:contacto@cristourviajes.cl">contacto@cristourviajes.cl</a>
            </div>
          </div>

          {/* Contenedor principal */}
          <div className="mc-auth-container">
            {/* Contenedor único - Error */}
            <div className="mc-auth-welcome">
              <div className="mc-auth-welcome-content">
                <h1 className="mc-auth-welcome-title">Código<br />inválido</h1>
                <p className="mc-auth-welcome-subtitle">El código ingresado no es válido o ha expirado.</p>
              </div>

              {/* Botón de retorno */}
              <div className="mc-auth-form-wrapper">
                <h2 className="mc-auth-form-title">Error</h2>
                <p className="mc-auth-form-subtitle">Por favor, intenta nuevamente</p>

                <AnchorComponent to="/recuperar-password" className="mc-auth-btn-submit" style={{display: 'inline-block', width: '100%', textAlign: 'center', padding: '14px 22px', textDecoration: 'none'}}>
                  VOLVER A INTENTAR
                </AnchorComponent>
              </div>
            </div>
          </div>

          {/* Footer con características */}
          <footer className="mc-auth-footer">
            <div className="mc-auth-footer-content">
              <div className="mc-auth-feature-card">
                <div className="mc-auth-feature-icon">
                  <img src="/images/trips.png" alt="Mis Giras" onError={(e) => e.target.style.display = 'none'} />
                </div>
                <h3 className="mc-auth-feature-title">Mis Giras</h3>
                <p className="mc-auth-feature-desc">Revisa itinerarios, fechas, servicios y documentos de tus giras.</p>
              </div>

              <div className="mc-auth-feature-card">
                <div className="mc-auth-feature-icon">
                  <img src="/images/passengers.png" alt="Pasajeros" onError={(e) => e.target.style.display = 'none'} />
                </div>
                <h3 className="mc-auth-feature-title">Pasajeros</h3>
                <p className="mc-auth-feature-desc">Consulta la lista de pasajeros, datos y documentación.</p>
              </div>

              <div className="mc-auth-feature-card">
                <div className="mc-auth-feature-icon">
                  <img src="/images/payments.png" alt="Pagos" onError={(e) => e.target.style.display = 'none'} />
                </div>
                <h3 className="mc-auth-feature-title">Pagos</h3>
                <p className="mc-auth-feature-desc">Visualiza montos y fechas de pagos de tu gira.</p>
              </div>

              <div className="mc-auth-feature-card">
                <div className="mc-auth-feature-icon">
                  <img src="/images/documents.png" alt="Documentos" onError={(e) => e.target.style.display = 'none'} />
                </div>
                <h3 className="mc-auth-feature-title">Documentos</h3>
                <p className="mc-auth-feature-desc">Descarga contratos, coberturas y documentos importantes.</p>
              </div>
            </div>
          </footer>
        </div>
     }
    </div>
  );
}